<template>
  <div class="typewriter mt-5">
    <div class="typewriter-container">
      <h3 class="header-animated">We cover 190+ countries across the globe</h3>
      <p class="typewriter__subtitle text-center">
        <router-link to="/coverage" class="typewriter__link">Explore our coverage</router-link>
      </p>
    </div>

    <video playsinline autoplay muted loop class="rounded mx-auto d-block w-100">
      <source src="https://res.cloudinary.com/dmhhkhgny/video/upload/v1745406687/website/rkzwufc7r3zgeuauonon.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'TypewriterComponent',
};
</script>

<style scoped>
:root {
  --typewriterSpeed: 6s;
  --typewriterCharacters: 40;
}

html, body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

.typewriter {
  position: relative;
  width: 100vw;
}

.typewriter-container {
  position: absolute;
  left: 10%;
  top: 50%;
  z-index: 1;
  font-family: 'Source Sans Pro', sans-serif;
  transform: translateY(-50%);
}

.typewriter__link {
  text-decoration: none;
  color: #fff;
}

.typewriter__link:hover {
  color: #00AEEF;
}

.typewriter__subtitle {
  color: #fff;
  font-size: 2rem;
  font-weight: normal;
  opacity: 0;
  transform: translateY(3rem);
  animation: fadeInUp 1s ease-in-out forwards;
  animation-delay: 6s;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0.3);
  padding: 0.5rem 1rem;
  border-radius: 6px;
}

.header-animated {
  font-family: 'Source Code Pro', monospace;
  font-size: clamp(1rem, 3vw + 1rem, 5.2rem);
  font-weight: bold;
  position: relative;
  width: max-content;
  margin: auto;
  color: #fff;
  font-size: 60px;
}

.header-animated::before,
.header-animated::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.header-animated::before {
  background: rgba(0, 0, 0, 0.5);
  animation: typewriter var(--typewriterSpeed) steps(var(--typewriterCharacters)) 1s forwards;
}

.header-animated::after {
  width: 0.125em;
  background: #fff;
  animation:
    typewriter var(--typewriterSpeed) steps(var(--typewriterCharacters)) 1s forwards,
    blink 300ms steps(var(--typewriterCharacters)) infinite;
}

@keyframes typewriter {
  to {
    left: 100%;
  }
}

@keyframes blink {
  to {
    background: transparent;
  }
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (min-width: 1440px) {
  .typewriter-container {
    left: 5%;
  }

  .header-animated {
    font-size: clamp(2rem, 3vw + 1rem, 5.2rem);
  }

  .typewriter__subtitle {
    font-size: 2rem;
  }
}

@media screen and (max-width: 1440px) and (min-width: 992px) {
  .typewriter-container {
    left: 8%;
  }

  .header-animated {
    font-size: clamp(1.5rem, 3vw + 1rem, 4.5rem);
  }

  .typewriter__subtitle {
    font-size: 1.8rem;
  }
}

@media screen and (max-width: 992px) and (min-width: 768px) {
  .typewriter-container {
    left: 6%;
    top: 45%;
  }

  .header-animated {
    font-size: clamp(1rem, 3vw + 1rem, 3.5rem);
  }

  .typewriter__subtitle {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 768px) {
  .typewriter-container {
    left: 5%;
    top: 40%;
  }

  .header-animated {
    font-size: clamp(1rem, 3vw + 1rem, 2.5rem);
  }

  .typewriter__subtitle {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 400px) {
  .typewriter-container {
    left: 3%;
    top: 35%;
  }

  .header-animated {
    font-size: clamp(1rem, 3vw + 1rem, 1.5rem);
  }

  .typewriter__subtitle {
    font-size: 1rem;
  }
}

img {
  max-width: 100%;
  height: auto;
}

video {
  max-width: 100%;
  height: auto;
}

.typewriter,
.typewriter-container,
.header-animated {
  max-width: 100%;
  overflow: hidden;
}


</style>
